{
  "version": "1.2.6",
  "objects": {
    "7431911322587806742": {
      "type": "frame",
      "id": "7431911322587806742",
      "z": 7076,
      "textContent": "",
      "left": 1898.6147634118038,
      "top": 339.40089080975383,
      "width": 400,
      "height": 500,
      "scaleX": 1.282870236650997,
      "scaleY": 0.6940333076064749,
      "fill": "#FFFFFF",
      "opacity": 1,
      "container": null,
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a1V",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "user",
      "layoutSizeVertical": "user",
      "layoutGap": 20,
      "layoutPadding": 20,
      "layoutDirection": "vertical",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "top"
    },
    "7431911322592810901": {
      "type": "frame",
      "id": "7431911322592810901",
      "z": 6938,
      "textContent": "Frame 14",
      "left": 1918.6147634118038,
      "top": 359.40089080975383,
      "width": 400,
      "height": 500,
      "scaleX": 1.1828702366509969,
      "scaleY": 0.102,
      "fill": "transparent",
      "opacity": 1,
      "container": "7431911322587806742",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "a0z",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7431911322603483925": {
      "type": "frame",
      "id": "7431911322603483925",
      "z": 6939,
      "textContent": "Frame 14",
      "left": 1918.6147634118038,
      "top": 359.40089080975383,
      "width": 400,
      "height": 500,
      "scaleX": 0.2144965950791726,
      "scaleY": 0.102,
      "fill": "transparent",
      "opacity": 1,
      "container": "7431911322592810901",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": null,
      "layoutEnabled": true,
      "layoutSizeHorizontal": "children",
      "layoutSizeVertical": "user",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "center",
      "layoutAlignVertical": "center"
    },
    "7431911322601960185": {
      "type": "shape",
      "id": "7431911322601960185",
      "z": 6940,
      "shapeName": "icon",
      "textContent": "",
      "left": 1918.6147634118038,
      "top": 373.0015717939193,
      "width": 100,
      "height": 100,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.23798638031669025,
      "scaleY": 0.23798638031669025,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": "#D23131",
      "angle": 0,
      "container": "7431911322603483925",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "Zyzz",
      "maskType": "none",
      "iconName": "fas/triangle-exclamation",
      "locked": false
    },
    "7431911322591346364": {
      "type": "shape",
      "id": "7431911322591346364",
      "z": 6942,
      "shapeName": "text",
      "textContent": "<p>Title</p>",
      "left": 1942.4134014434728,
      "top": 359.40089080975383,
      "width": 36.16666666666667,
      "height": 29.75,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 1.7142857142857142,
      "scaleY": 1.7142857142857142,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textAlign": "left",
      "fontSize": 24,
      "angle": 0,
      "container": "7431911322603483925",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "Zz",
      "maskType": "none",
      "locked": false
    },
    "7431911322598252650": {
      "type": "shape",
      "id": "7431911322598252650",
      "z": 6941,
      "shapeName": "icon",
      "textContent": "",
      "left": 2376.6360570579263,
      "top": 374.399449998333,
      "width": 100,
      "height": 160,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.13126801014276016,
      "scaleY": 0.13126801014276016,
      "stroke": null,
      "strokeWidth": 2,
      "opacity": 0.3,
      "borderOpacity": 1,
      "fill": "#333333",
      "angle": 0,
      "container": "7431911322592810901",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a0",
      "maskType": "none",
      "iconName": "fas/xmark",
      "locked": false
    },
    "7431911322598661674": {
      "type": "frame",
      "id": "7431911322598661674",
      "z": 6943,
      "textContent": "Frame 20",
      "left": 1918.6147634118038,
      "top": 627.4008908097538,
      "width": 400,
      "height": 500,
      "scaleX": 1.1828702366509969,
      "scaleY": 0.07971875,
      "fill": "transparent",
      "opacity": 1,
      "container": "7431911322587806742",
      "notInNavigation": false,
      "componentName": "",
      "layoutPosition": "aO",
      "layoutEnabled": true,
      "layoutSizeHorizontal": "parent",
      "layoutSizeVertical": "children",
      "layoutGap": "auto",
      "layoutPadding": 0,
      "layoutDirection": "horizontal",
      "layoutAlignHorizontal": "left",
      "layoutAlignVertical": "center"
    },
    "7431911322587413480": {
      "type": "wireframe",
      "id": "7431911322587413480",
      "z": 6944,
      "top": 627.9008908097538,
      "left": 1918.6147634118038,
      "width": 59.79296875,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911322598661674",
      "layoutPosition": "a0",
      "wireframeName": "button",
      "fill": "#B6B6B6",
      "textColor": null,
      "style": "square",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Close" }
    },
    "7431911322601246691": {
      "type": "wireframe",
      "id": "7431911322601246691",
      "z": 6946,
      "top": 627.9008908097538,
      "left": 2316.7560221347026,
      "width": 73.0068359375,
      "height": 39.859375,
      "scaleX": 1,
      "scaleY": 1,
      "container": "7431911322598661674",
      "layoutPosition": "a1",
      "wireframeName": "button",
      "fill": "#D23131",
      "textColor": null,
      "style": "squareFilled",
      "fontSize": 14,
      "label": {},
      "placeholder": { "state": "default", "value": "Confirm" }
    },
    "7431911322602493231": {
      "type": "shape",
      "id": "7431911322602493231",
      "z": 6945,
      "shapeName": "text",
      "textContent": "<p>Paragraph text</p><p><br /></p><p><br /></p><p><br /></p><p><br /></p><p><br /></p><p><br /></p><p><br /></p><p><br /></p><p><br /></p>",
      "left": 1918.6147634118038,
      "top": 430.40089080975383,
      "width": 547.8134453621971,
      "height": 205.43004201082388,
      "strokeType": null,
      "strokeDouble": false,
      "scaleX": 0.8616071839710477,
      "scaleY": 0.8616071839710477,
      "stroke": null,
      "strokeWidth": 0,
      "opacity": 1,
      "borderOpacity": 1,
      "fill": null,
      "textOpacity": 0.4,
      "textAlign": "left",
      "fontSize": 12.062500575594669,
      "angle": 0,
      "container": "7431911322587806742",
      "authorId": "7241647490532477456",
      "showAuthor": true,
      "layoutPosition": "a1",
      "wrapText": true,
      "maskType": "none",
      "locked": false,
      "reactions": {}
    }
  }
}
